import { ListagemPadrao } from "../../padronizado/listagem-padrao";
import { UsuarioVisualizadoInterface } from "../../../types/UsuarioInterface";
import { verificaSeAtivoERetornaBadge } from "../../../utils/verificaSeAtivoERetornaBadge/verificaSeAtivoERetornaBadge";

export const Usuario: React.FC = () => {
  // Definição das colunas da tabela
  const colunas: {
    titulo: string;
    campo: keyof UsuarioVisualizadoInterface | ((item: UsuarioVisualizadoInterface) => React.ReactNode);
    alinhamento?: 'start' | 'center' | 'end';
  }[] = [
    { titulo: "Código", campo: "id_usuario" },
    { titulo: "Nome", campo: "nome" },
    { titulo: "Usuário", campo: "nome_usuario" },
    { titulo: "E-mail", campo: "email" },
    { titulo: "Telefone", campo: "telefone" },
    { 
      titulo: "Situação", 
      campo: (usuario) => verificaSeAtivoERetornaBadge(String(usuario.situacao)),
      alinhamento: "center" 
    },
  ];

  // Campos que serão utilizados na pesquisa
  const camposPesquisa: (keyof UsuarioVisualizadoInterface)[] = [
    "nome",
    "nome_usuario"
  ];

  // Função para personalizar a mensagem de confirmação de exclusão
  const mensagemConfirmacaoExclusao = (usuario: UsuarioVisualizadoInterface) => {
    return `Tem certeza que deseja excluir o usuário(a) \n ${usuario.nome}?`;
  };

  return (
    <ListagemPadrao<UsuarioVisualizadoInterface>
      titulo="Usuários"
      endpoint="/usuarios"
      colunas={colunas}
      campoId="id_usuario"
      rotaBase="/cadastro/usuario"
      camposPesquisa={camposPesquisa}
      usaPaginacaoServidor={true}
      mensagemConfirmacaoExclusao={mensagemConfirmacaoExclusao}
    />
  );
}; 